// extracted by mini-css-extract-plugin
export default {"no-results-row":"tableNoResults_no-results-row__S10q6"};